module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/spot_01@2x-ff570fad730d41fb71d639b30afaa67d.webp";